import {MarginQuizQuestionController} from "./MarginQuizQuestionController";
import {BULL_CALL, MARGINED_STRATEGY} from "../MarginQuizQuestions";

export const MarginedStrategies = "tfMarginedStrategiesQuestion";

export function marginedStrategies() {
    return {
        templateUrl: "app/quiz/margin/questions/MarginedStrategies.html",
        bindings: {
            previousAnswer: "<",
            onAnswer: "&"
        },
        controllerAs: "ctrl",
        controller: MarginedStrategiesController
    };
}

export class MarginedStrategiesController extends MarginQuizQuestionController {
    public config = MARGINED_STRATEGY;
}
